import React from "react";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

export default function Career() {
  return (
    <div className="slider-wrapper">
      <div className="container">
        <div className="row mt63">
          <div className="col-sm-12">
            <div className="mainbdr whitebg">
              <div className="row">
                <div className="col-sm-3">
                  <Sidebar />
                </div>
                <div class="col-sm-9 " style={{ marginTop: "5px" }}>
                  <div class="row mt0">
                    <div class="col-sm-12">
                      <div class="inner_content contactpage">
                        <h2>QUALITY CONTROL</h2>
                        <div class="clearfix"></div>
                        <p>
                          Good Manufacturing Practices and the Quality Control
                          drill including Good Laboratory Practices are the two
                          decisive factors for assuring the excellence of end
                          products at IDPL.
                        </p>
                        <p>
                          IDPL’ s products meet world standard in quality. The
                          company has full-fledged Quality Control Departments
                          at its all manufacturing units. These are headed by
                          qualified and experienced personnel and equipped with
                          latest analytical tools and instruments.
                        </p>
                        <p>
                          IDPL knows that health of the people is too precious
                          to be risked. So, the Quality Control Departments are
                          kept closely involved at every stage of production.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <Footer />
            </div>

            <div className="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
